module.exports = __webpack_public_path__ + "img/gal-14.37943227.jpg";